import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuoteLeft, faQuoteRight } from "@fortawesome/free-solid-svg-icons";

const TestCard = ({ testimonials }) => {
  const { t } = useTranslation();

  return (
    <div className="row justify-content-center">
      <div className="col-lg-10">
        {testimonials.map(({ id, image, name }) => (
          <div
            key={id}
            className="card testimonial-showcase-card border-0 shadow-sm rounded-4 p-4 p-md-5 mb-4 bg-white"
          >
            <div className="row align-items-center g-4">
              <div className="col-md-4 text-center">
                <div className="testimonial-avatar-wrapper d-inline-block position-relative">
                  <img
                    src={image}
                    alt={name}
                    className="img-fluid rounded-circle shadow testimonial-avatar-img"
                    style={{ width: "130px", height: "130px", objectFit: "cover" }}
                    loading="lazy"
                  />
                  <div className="avatar-gold-badge">
                    <FontAwesomeIcon icon={faQuoteLeft} className="small" />
                  </div>
                </div>
                <h5 className="testimonial-author-name mt-3 mb-0 fw-bold">{name}</h5>
              </div>

              <div className="col-md-8">
                <div className="testimonial-quote-box position-relative ps-md-3">
                  <p className="testimonial-text mb-0 fs-5 fst-italic text-secondary">
                    <FontAwesomeIcon
                      icon={faQuoteLeft}
                      className="text-warning me-2 opacity-75 small"
                    />
                    {t(`testimonials.${id}`)}
                    <FontAwesomeIcon
                      icon={faQuoteRight}
                      className="text-warning ms-2 opacity-75 small"
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestCard;
